import React from "react";
import noDataImage from "../../assets/images/no-data.jpg";

const NoDataPlaceholder = () => {
  return (
    <div className="center-align-container">
      <img className="no-data-image" src={noDataImage} alt="no-data" />
    </div>
  );
};

export default NoDataPlaceholder;
